import * as api from '../../../clients/veranstaltungen';

import {Action} from '@ngrx/store';

export const POST_FUNKPROTOKOLL_MANDANT_OPTIONS_SPEICHERN = '[VeranstaltungenModul] PostFunkprotokollMandantOptionsSpeichern laden';
export const POST_FUNKPROTOKOLL_MANDANT_OPTIONS_SPEICHERN_AUSFUEHREN = '[VeranstaltungenModul] PostFunkprotokollMandantOptionsSpeichern ausführen';
export const POST_FUNKPROTOKOLL_MANDANT_OPTIONS_SPEICHERN_ERFOLGREICH = '[VeranstaltungenModul] PostFunkprotokollMandantOptionsSpeichern laden erfolgreich';
export const POST_FUNKPROTOKOLL_MANDANT_OPTIONS_SPEICHERN_FEHLER = '[VeranstaltungenModul] PostFunkprotokollMandantOptionsSpeichern Ladefehler';
export const POST_FUNKPROTOKOLL_MANDANT_OPTIONS_SPEICHERN_NICHT_AUSGEFUEHRT = '[VeranstaltungenModul] PostFunkprotokollMandantOptionsSpeichern nicht ausgeführt (evtl. Offline)';


export class PostFunkprotokollMandantOptionsSpeichernAction implements Action {
    readonly type = POST_FUNKPROTOKOLL_MANDANT_OPTIONS_SPEICHERN;
        constructor(public funkprotokollMandantOptions: api.FunkprotokollMandantOptions, public optPayload: any = null) {}
    }
export class PostFunkprotokollMandantOptionsSpeichernAusfuehrenAction implements Action {
    readonly type = POST_FUNKPROTOKOLL_MANDANT_OPTIONS_SPEICHERN_AUSFUEHREN;
        constructor(public funkprotokollMandantOptions: api.FunkprotokollMandantOptions, public optPayload: any = null) {}
    }
export class PostFunkprotokollMandantOptionsSpeichernErfolgreichAction implements Action {
    readonly type = POST_FUNKPROTOKOLL_MANDANT_OPTIONS_SPEICHERN_ERFOLGREICH;
        constructor(public funkprotokollMandantOptions: api.FunkprotokollMandantOptions, public optPayload: any = null) {}
    }
export class PostFunkprotokollMandantOptionsSpeichernFehlerAction implements Action {
    readonly type = POST_FUNKPROTOKOLL_MANDANT_OPTIONS_SPEICHERN_FEHLER;
        constructor(public payload: any, public funkprotokollMandantOptions: api.FunkprotokollMandantOptions, public optPayload: any = null) {}
    }
export class PostFunkprotokollMandantOptionsSpeichernNichtAusgefuehrtAction implements Action {
    readonly type = POST_FUNKPROTOKOLL_MANDANT_OPTIONS_SPEICHERN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VeranstaltungenCommandFunkprotokollMandantOptionsSpeichernActions =
    PostFunkprotokollMandantOptionsSpeichernAction
    | PostFunkprotokollMandantOptionsSpeichernAusfuehrenAction
    | PostFunkprotokollMandantOptionsSpeichernErfolgreichAction
    | PostFunkprotokollMandantOptionsSpeichernFehlerAction
    | PostFunkprotokollMandantOptionsSpeichernNichtAusgefuehrtAction
    ;
